$(document).on('change', '#selection-modal input[type="checkbox"]', function() {
  if ($('#selection-modal input[type="checkbox"]:checked').length) {
    $('.popup__reset-selection').removeAttr('disabled');
  } else {
    $('.popup__reset-selection').attr('disabled', true);
  }
})

$(document).on('click', '.popup__reset-selection', function() {
  $('#selection-modal input[type="checkbox"]').each(function() {
    this.checked = false;
  });
  $(this).attr('disabled', true);
})
